import axios from 'axios';
import {withAuthLogoutOn401} from "../utils/authTokens";

// AI flow builder backend (website scrape and flow generation)
const instance = axios.create({
    baseURL: `${process.env.REACT_APP_AI_FLOW_BUILDER}`
});

withAuthLogoutOn401(instance);

export default instance;
